import { useState } from 'react';
import { mockDocuments } from '../../mocks/documents';
import { useNavigate } from 'react-router-dom';

export default function DocumentManagement() {
  const [documents] = useState(mockDocuments);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState<any>(null);
  const [filterStatus, setFilterStatus] = useState('全部');
  const navigate = useNavigate();

  const statusColors: Record<string, string> = {
    已归档: 'bg-slate-100 text-slate-700',
    解析中: 'bg-blue-100 text-blue-700',
    待审核: 'bg-amber-100 text-amber-700',
    待解析: 'bg-purple-100 text-purple-700',
    失败: 'bg-red-100 text-red-700'
  };

  const filteredDocuments =
    filterStatus === '全部'
      ? documents
      : documents.filter((doc) => doc.status === filterStatus);

  const handleViewDetail = (doc: any) => {
    setSelectedDocument(doc);
    setShowDetailModal(true);
  };

  // 根据状态渲染不同的操作按钮
  const renderActions = (doc: any) => {
    switch (doc.status) {
      case '待解析':
        return (
          <button 
            className="px-3 py-1.5 text-sm text-slate-600 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            删除
          </button>
        );
      
      case '解析中':
        return (
          <button 
            className="px-3 py-1.5 text-sm text-slate-600 hover:text-orange-600 hover:bg-orange-50 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            停止
          </button>
        );
      
      case '待审核':
        return (
          <div className="flex items-center gap-1">
            <button 
              onClick={() => navigate('/extraction')}
              className="px-3 py-1.5 text-sm text-slate-600 hover:text-blue-600 hover:bg-slate-50 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              审核
            </button>
            <button 
              className="px-3 py-1.5 text-sm text-slate-600 hover:text-amber-600 hover:bg-slate-50 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              重新解析
            </button>
            <button 
              className="px-3 py-1.5 text-sm text-slate-600 hover:text-red-600 hover:bg-slate-50 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              删除
            </button>
          </div>
        );
      
      case '已归档':
        return (
          <div className="flex items-center gap-1">
            <button 
              onClick={() => handleViewDetail(doc)}
              className="px-3 py-1.5 text-sm text-slate-600 hover:text-blue-600 hover:bg-slate-50 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              查看
            </button>
            <button 
              className="px-3 py-1.5 text-sm text-slate-600 hover:text-amber-600 hover:bg-slate-50 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              重新解析
            </button>
            <button 
              className="px-3 py-1.5 text-sm text-slate-600 hover:text-red-600 hover:bg-slate-50 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              删除
            </button>
          </div>
        );
      
      default:
        return null;
    }
  };

  return (
    <div className="p-8">
      {/* 头部操作栏 */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-4">
          <h2 className="text-xl font-semibold text-slate-900">文档列表</h2>
          <div className="flex items-center gap-2">
            {['全部', '待解析', '解析中', '待审核', '已归档'].map((status) => (
              <button
                key={status}
                onClick={() => setFilterStatus(status)}
                className={`px-4 py-1.5 text-sm rounded-full transition-colors cursor-pointer whitespace-nowrap ${
                  filterStatus === status
                    ? 'bg-blue-600 text-white'
                    : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                }`}
              >
                {status}
              </button>
            ))}
          </div>
        </div>

        <button
          onClick={() => setShowUploadModal(true)}
          className="px-5 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2 text-sm font-medium cursor-pointer whitespace-nowrap"
        >
          <i className="ri-upload-cloud-line text-base"></i>
          上传文档
        </button>
      </div>

      {/* 统计卡片 */}
      <div className="grid grid-cols-4 gap-6 mb-8">
        <div className="bg-white rounded-lg p-6 border border-slate-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-500 mb-1">总文档数</p>
              <p className="text-3xl font-semibold text-slate-900">156</p>
            </div>
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <i className="ri-file-text-line text-2xl text-blue-600"></i>
            </div>
          </div>
          <p className="text-xs text-green-600 mt-3">
            <i className="ri-arrow-up-line"></i> 本月新增 18 个
          </p>
        </div>

        <div className="bg-white rounded-lg p-6 border border-slate-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-500 mb-1">已抽取规则</p>
              <p className="text-3xl font-semibold text-slate-900">1,247</p>
            </div>
            <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center">
              <i className="ri-lightbulb-line text-2xl text-indigo-600"></i>
            </div>
          </div>
          <p className="text-xs text-green-600 mt-3">
            <i className="ri-arrow-up-line"></i> 本月新增 186 条
          </p>
        </div>

        <div className="bg-white rounded-lg p-6 border border-slate-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-500 mb-1">解析中</p>
              <p className="text-3xl font-semibold text-slate-900">3</p>
            </div>
            <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center">
              <i className="ri-loader-4-line text-2xl text-amber-600"></i>
            </div>
          </div>
          <p className="text-xs text-slate-500 mt-3">预计完成 2小时</p>
        </div>

        <div className="bg-white rounded-lg p-6 border border-slate-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-500 mb-1">待审核文档</p>
              <p className="text-3xl font-semibold text-slate-900">12</p>
            </div>
            <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
              <i className="ri-file-warning-line text-2xl text-orange-600"></i>
            </div>
          </div>
          <p className="text-xs text-slate-500 mt-3">需要人工审核</p>
        </div>
      </div>

      {/* 文档表格 */}
      <div className="bg-white rounded-lg border border-slate-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-200">
                <th className="text-left px-6 py-4 text-sm font-semibold text-slate-700">文档名称</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-slate-700">所属域</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-slate-700">上传日期</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-slate-700">状态</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-slate-700">解析域</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-slate-700">规则数</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-slate-700">操作</th>
              </tr>
            </thead>
            <tbody>
              {filteredDocuments.map((doc) => (
                <tr key={doc.id} className="border-b border-slate-100 hover:bg-slate-50">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className={`ri-file-${doc.type === 'PDF' ? 'pdf' : 'word'}-line text-xl text-slate-600`}></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-slate-900">{doc.name}</p>
                        <p className="text-xs text-slate-500">
                          {doc.version} {doc.previousVersion && `(旧版: ${doc.previousVersion})`}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <span className="px-3 py-1 bg-indigo-100 text-indigo-700 rounded-full text-xs font-medium whitespace-nowrap">
                      {doc.domain}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600">{doc.uploadDate}</td>
                  <td className="px-6 py-4">
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                        statusColors[doc.status]
                      }`}
                    >
                      {doc.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600">{doc.parseScope}</td>
                  <td className="px-6 py-4">
                    <span className="text-sm text-slate-900">{doc.rulesExtracted || '-'}</span>
                  </td>
                  <td className="px-6 py-4">
                    {renderActions(doc)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 上传弹窗 */}
      {showUploadModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-2xl p-8">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-semibold text-slate-900">上传文档</h3>
              <button
                onClick={() => setShowUploadModal(false)}
                className="w-8 h-8 flex items-center justify-center hover:bg-slate-100 rounded-md transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl text-slate-600"></i>
              </button>
            </div>

            <div className="border-2 border-dashed border-slate-300 rounded-lg p-12 text-center mb-6 hover:border-blue-500 transition-colors cursor-pointer">
              <i className="ri-upload-cloud-2-line text-5xl text-slate-400 mb-4"></i>
              <p className="text-sm text-slate-600 mb-2">拖拽文件到此处或点击上传</p>
              <p className="text-xs text-slate-400">支持 PDF、Word 格式，单个文件不超过 50MB</p>
            </div>

            <div className="space-y-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">所属域</label>
                <select className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm">
                  <option>财务域</option>
                  <option>生产域</option>
                  <option>行政域</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">解析域配置</label>
                <select className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm">
                  <option>全文解析</option>
                  <option>指定章节</option>
                  <option>指定页码</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">关联旧版本（可选）</label>
                <select className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm">
                  <option>无</option>
                  <option>员工行为规范管理制度 v1.0</option>
                  <option>财务报销流程规定 v1.0</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">所属部门</label>
                <select className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm">
                  <option>人力资源部</option>
                  <option>财务部</option>
                  <option>项目管理部</option>
                  <option>技术部</option>
                  <option>采购部</option>
                </select>
              </div>
            </div>

            <div className="flex items-center justify-end gap-3">
              <button
                onClick={() => setShowUploadModal(false)}
                className="px-5 py-2.5 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors text-sm font-medium cursor-pointer whitespace-nowrap"
              >
                取消
              </button>
              <button className="px-5 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium cursor-pointer whitespace-nowrap">
                开始上传
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 查看详情弹窗 */}
      {showDetailModal && selectedDocument && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-3xl p-8">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-semibold text-slate-900">文档详情</h3>
              <button
                onClick={() => setShowDetailModal(false)}
                className="w-8 h-8 flex items-center justify-center hover:bg-slate-100 rounded-md transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl text-slate-600"></i>
              </button>
            </div>

            <div className="space-y-6">
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-slate-500 mb-1">文档名称</label>
                  <p className="text-sm text-slate-900">{selectedDocument.name}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-500 mb-1">所属域</label>
                  <span className="px-3 py-1 bg-indigo-100 text-indigo-700 rounded-full text-xs font-medium">
                    {selectedDocument.domain}
                  </span>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-500 mb-1">所属部门</label>
                  <p className="text-sm text-slate-900">{selectedDocument.department}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-500 mb-1">上传日期</label>
                  <p className="text-sm text-slate-900">{selectedDocument.uploadDate}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-500 mb-1">当前版本</label>
                  <p className="text-sm text-slate-900">{selectedDocument.version}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-500 mb-1">旧版本</label>
                  <p className="text-sm text-slate-900">{selectedDocument.previousVersion || '无'}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-500 mb-1">状态</label>
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-medium ${
                      statusColors[selectedDocument.status]
                    }`}
                  >
                    {selectedDocument.status}
                  </span>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-500 mb-1">解析域</label>
                  <p className="text-sm text-slate-900">{selectedDocument.parseScope}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-500 mb-1">已抽取规则</label>
                  <p className="text-sm text-slate-900">{selectedDocument.rulesExtracted} 条</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-500 mb-1">上传者</label>
                  <p className="text-sm text-slate-900">{selectedDocument.uploader}</p>
                </div>
              </div>

              <div className="pt-4 border-t border-slate-200">
                <h4 className="text-sm font-semibold text-slate-900 mb-3">解析进度</h4>
                <div className="space-y-3">
                  {selectedDocument.status === '已归档' && (
                    <>
                      <div className="flex items-center gap-3">
                        <i className="ri-check-circle-fill text-green-600"></i>
                        <div className="flex-1">
                          <p className="text-sm text-slate-900">文档上传完成</p>
                          <p className="text-xs text-slate-500">2024-01-15 10:30:00</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <i className="ri-check-circle-fill text-green-600"></i>
                        <div className="flex-1">
                          <p className="text-sm text-slate-900">AI解析完成</p>
                          <p className="text-xs text-slate-500">2024-01-15 11:45:00</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <i className="ri-check-circle-fill text-green-600"></i>
                        <div className="flex-1">
                          <p className="text-sm text-slate-900">人工审核完成</p>
                          <p className="text-xs text-slate-500">2024-01-15 14:20:00</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <i className="ri-check-circle-fill text-green-600"></i>
                        <div className="flex-1">
                          <p className="text-sm text-slate-900">规则已归档</p>
                          <p className="text-xs text-slate-500">2024-01-15 14:25:00</p>
                        </div>
                      </div>
                    </>
                  )}
                  {selectedDocument.status === '解析中' && (
                    <>
                      <div className="flex items-center gap-3">
                        <i className="ri-check-circle-fill text-green-600"></i>
                        <div className="flex-1">
                          <p className="text-sm text-slate-900">文档上传完成</p>
                          <p className="text-xs text-slate-500">2024-01-15 10:30:00</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <i className="ri-loader-4-line text-blue-600 animate-spin"></i>
                        <div className="flex-1">
                          <p className="text-sm text-slate-900">AI解析中...</p>
                          <p className="text-xs text-slate-500">预计还需 1 小时</p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="flex items-center justify-end gap-3 mt-6 pt-6 border-t border-slate-200">
              <button
                onClick={() => setShowDetailModal(false)}
                className="px-5 py-2.5 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors text-sm font-medium cursor-pointer whitespace-nowrap"
              >
                关闭
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
